const initstate = {
  loggedIn: false,
  authToken: "",
  user: null,
  backurl: process.env.REACT_APP_BACKEND_SERVER ,
  expireDate:''
};
export const authReducer = (state = initstate, action) => {

  switch (action.type) {
    case "login":
      return {
        loggedIn: true,
        user: action.payload.user,
        authToken: action.payload.authToken,
        backurl: action.payload.backurl,
        expireDate :action.payload.expireDate,

      };
    case "logout":
      return {
        loggedIn: false,
        authToken: "",
        user: null,
        backurl: null,
        expireDate: '',
      };
    default:
      return state;
  }
};
export const authActions = {
  login: (userInfo) => ({ type: "login", payload: userInfo }),
  logout: () => ({ type: "logout", payload: "" }),
};
